'use strict';
const angular = require('angular');

export class BulletinPostComponent {
  /*@ngInject*/
  constructor() {

    this.$onChanges = function (changesObj) {
      if (changesObj.data && this.data && this.data.attachments) {
        var that = this;

        this.galleryImages = this.data.attachments.filter(attachment => {
          return that.isImageMime(attachment.contentType);
        });

        this.galleryImages = this.galleryImages.map(obj => {
          let rObj = {};

          rObj.title = obj.filename;
          rObj.alt = obj.filename;

          rObj.url = that.getStoragePath(obj._id);
          rObj.thumbUrl = '/api/storage/' + obj._id + '/thumb';

          return rObj;
        });
      }
    };
  }

  getStoragePath(id) {
    if (this.public || this.property || this.realtor) {
      return "/api/storage/public/"+id+"/ctx/"+this.getContext(this.data);
    }

    return "/api/storage/"+id;
  }

  getPreviewText(text) {
    return text ? String(text).replace(/<[^>]+>/gm, ' ').substr(0, 300) + '...' : '';
  }

  getUserShort(user) {
    try {
      return (user) ? user.firstName + " " + user.lastName[0] + "." : "unknown";
    } catch(e) {
      return "unknown";
    }
  }

  isImageMime(mime) {
    return mime.startsWith('image/');
  }

  isPdfMime(mime) {
    return mime === 'application/pdf';
  }

  getContext(data) {
    return btoa("bulletin:"+data._id);
  }
}

export default angular.module('conduuApp.bulletinPost', [])
  .component('bulletinPost', {
    template: require('./BulletinPost.html'),
    bindings: {
      preview: '<',
      detail: '<',
      data: '<',
      user: '<',
      admin: '<',
      delete: '&',
      public: '<',
      property: '<',
      realtor: '<',
      history: '<',
      url: '@'
    },
    controller: BulletinPostComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/bulletin/post/BulletinPost.component.js